module.exports = __webpack_public_path__ + "img/total_drivers.e8386b8a.svg";